import { render } from "./TouchInterface.vue?vue&type=template&id=44622358&scoped=true&ts=true"
import script from "./TouchInterface.vue?vue&type=script&lang=ts"
export * from "./TouchInterface.vue?vue&type=script&lang=ts"

import "./TouchInterface.vue?vue&type=style&index=0&id=44622358&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44622358"]])

export default __exports__